import { defineMessages } from 'react-intl';

const _default_1: {
	byAgentText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	byAgentText: {
		id: 'rovo-conversation-actions.actions.by-agent-text',
		defaultMessage: 'By {agentName}',
		description:
			'The secondary description text to indicate which agent the conversation starter is powered by, for example "By AI Agent"',
	},
});
export default _default_1;
